import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import pvricon from "../../assets/haptik/MJ BOT_PVR.png";
import inoxicon from "../../assets/haptik/MJ BOT_INOX.png";
import { getSplashData } from "src/services/OtherServices";
import MJChatBubble from './MJChatBubble';

const HaptikChat = () => {
  const token = sessionStorage.getItem('token');
  const [visible, setVisible] = useState(true);
  const [spalshData, setSpalshData] = useState(false);
  const [showBubble, setShowBubble] = useState(true);
  const [welcomeMessage, setwelcomeMessage] = useState(true);

  const loginDataValue = useSelector((state) => state.logindataValue?.value);
  const loginVewMode = useSelector((state) => state.loginViewMode.value);
  const selectedCity = useSelector((state) => state.cityChangeData?.city) || localStorage.getItem('city') || '';
  const cityChange = useSelector((state) => state.cityChangeData?.change);

  const loginInfo = typeof loginDataValue === 'string'
    ? JSON.parse(loginDataValue)
    : loginDataValue;

  const latitude = ['undefined', 'null', '', null].includes(localStorage.getItem('lat'))
    ? '0.000'
    : localStorage.getItem('lat');

  const longitude = ['undefined', 'null', '', null].includes(localStorage.getItem('long'))
    ? '0.000'
    : localStorage.getItem('long');

  const hasLocation =
    !['undefined', 'null', '', null].includes(latitude) &&
    !['undefined', 'null', '', null].includes(longitude) &&
    !!selectedCity;

  const theme = localStorage.getItem('theme') || 'pvrTheme';
  const loginInfos = JSON.parse(sessionStorage.getItem("loginInfo") || "null");
  const iconimage = theme === 'inoxTheme' ? inoxicon : pvricon;

  const location = useLocation();
  const imgRef = useRef(null);

  const getUniqueId = useCallback(() => {
    let id = localStorage.getItem("uniqueId");

    if (id && id.startsWith('guest') && loginInfos?.data?.mob) {
      id = null;
    }

    if (!id) {
      const randomId = `${Date.now()}-${Math.floor(Math.random() * 10000)}`;
      const newId = `${loginInfos?.data?.mob ? loginInfos.data.mob : 'guest'}-PVRWEB-${randomId}`;
      localStorage.setItem("uniqueId", newId);
      return newId;
    }

    return id;
  }, [loginInfos?.data?.mob]);

  const uniqueId = getUniqueId();
  const chatbotFlag = localStorage.getItem("chatbotticketbooked");
  const welcomeMessageShown = localStorage.getItem("Welcomemessage");
  const finalorderid = localStorage.getItem("finalbooking_Id");
  const message = `Get Booking Details {api_name: booking_details, booking_id: ${finalorderid}}`;

  useEffect(() => {
    getSplashData()
      .then((res) => {
        const dt = res.data;
        if (dt.result === "success") {
          setSpalshData(dt.output);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const iframe = document.querySelector('.xdk-iframe');
      const overlay = document.querySelector('.fullscreen-image-overlay');

      if (overlay && window.getComputedStyle(overlay).display !== 'none') {
        return;
      }

      if (iframe && !iframe.contains(event.target)) {
        if (window?.HaptikSDK?.hide) {
          localStorage.setItem('showChat', 'true');
          window.HaptikSDK.hide();
          setVisible(true);
          setShowBubble(false);
        }
      }
    };

    if (!visible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  const hideEventCallback = () => {
    setVisible(true);
  };

  const openChat = useCallback((e) => {
    const callbackWelcomeFunction = () => {
      setwelcomeMessage(false);
      localStorage.setItem("Welcomemessage", "true");
      localStorage.setItem("showbubblemessage", "true");
      setShowBubble(false);
    };

    const callbackBookingFunction = () => {
      localStorage.removeItem("finalbooking_Id");
      localStorage.removeItem("chatbotticketbooked");
      localStorage.setItem("Welcomemessage", "true");
    };

    if (window?.HaptikSDK?.show) {
      window.HaptikSDK.show();
      setVisible(false);

      if (chatbotFlag === "true") {
        setTimeout(() => {
          window.HaptikSDK.launchMessage(
            message,
            callbackBookingFunction,
            true,
            false,
            false,
            false,
            false
          );
        }, 100);
      } else if (welcomeMessageShown !== "true") {
        setTimeout(() => {
          window.HaptikSDK.launchMessage(
            "Hi",
            callbackWelcomeFunction,
            true,
            false,
            false,
            false,
            false
          );
        }, 100);
      }
    }
  }, [chatbotFlag, welcomeMessageShown, message]);

  useEffect(() => {
    const openOnReady = () => {
      if (location.pathname === "/mjbot" && !!selectedCity) {
        setTimeout(() => {
          openChat();
        }, 300);
      }
    };

    document.addEventListener("haptik_sdk", openOnReady);

    return () => {
      document.removeEventListener("haptik_sdk", openOnReady);
    };
  }, [location.pathname, openChat, selectedCity]);

  useEffect(() => {
    const source = theme === 'inoxTheme' ? 'inox' : 'pvr';
    const primaryColor = theme === 'inoxTheme' ? '#234B9E' : '#ffcb05';
    const customCSS = theme === 'inoxTheme' ? '/haptikbot-inox.css' : '/haptikbot.css';

    if (!window.haptikInitSettings) {
      window.haptikInitSettings = {
        'business-id': '7203',
        'client-id': 'cd4c4077ae7748763331badd8b3dd6da6a5211c3',
        'base-url': 'https://staging.hellohaptik.com/',
        'ignoreStorage': true,
        'primary-color': primaryColor,
        'source': source,
        'typography': 'Poppins',
        'custom-css': customCSS,
        'custom-button': true,
        'no-chat-bubble': false,
        'widget-positioning': "bottom-right",
        onChatWindowHide: hideEventCallback
      };

      const style = document.createElement('style');
      style.innerHTML = `
        @media (min-width: 768px) {
          .xdk-iframe {
            bottom: 0px !important;
            right: 0px !important;
            height: 90vh !important;
            max-height: 100%;
          }
        }
      `;
      document.head.appendChild(style);

      const script = document.createElement('script');
      script.src = 'https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js';
      script.async = true;
      document.body.appendChild(script);
    }

    const syncHaptikUser = () => {
      const customerData = {
        username: loginInfos?.data?.un || 'Guest',
        auth_id: uniqueId,
        email: loginInfos?.data?.em || '',
        current_city: selectedCity,
        source,
        current_lat: latitude || '0.000',
        current_long: longitude || '0.000',
        platform: "web",
        environment: "production",
        mobile_no: loginInfos?.data?.mob || '',
        location_time: new Date().toISOString(),
        access_token: {
          [loginInfos?.data?.mob || 'guest']: {
            token,
            expires: loginInfos?.access?.expires || '',
          },
        },
      };

      if (window.HaptikSDK?.signup && selectedCity) {
        window.HaptikSDK.signup(
          {
            username: customerData.username,
            auth_id: customerData.auth_id,
            auth_code: '8kBYLkqI7xOQPnvfcG4Y5Q==',
            email: customerData.email,
            custom_data: customerData,
          },
          (status, error) => {
            if (status) {
              window.HaptikSDK?.updateUserData?.(
                {
                  email: customerData.email,
                  mobile_no: customerData.mobile_no,
                  username: customerData.username,
                  custom_data: customerData,
                },
                (updateStatus, updateError) => {
                  if (!updateStatus) {
                    console.error("Update user data failed:", updateError);
                  }
                }
              );
            } else {
              console.error("Haptik signup failed:", error);
            }
          }
        );
      }
    };

    if (window.HaptikSDK) {
      syncHaptikUser();
    } else {
      document.addEventListener('haptik_sdk', syncHaptikUser);
    }

    return () => {
      document.removeEventListener('haptik_sdk', syncHaptikUser);
    };
  }, [loginDataValue, loginVewMode, selectedCity, latitude, longitude, token, uniqueId, theme]);

  return (
    spalshData?.chatbot === "true" &&
    visible &&
    !loginVewMode &&
    hasLocation &&
    (window.location.pathname === '/' || window.location.pathname === '/mjbot') && (
      <div className="mjbotshow">
        {showBubble &&
          !!selectedCity &&
          localStorage.getItem("showbubblemessage") !== "true" && (
            <MJChatBubble
              msg={spalshData?.mj_msg}
              timer={spalshData?.mj_msg_timer}
            />
          )}

        <img
          onClick={openChat}
          ref={imgRef}
          src={iconimage}
          alt="Chat with us"
          className="mj-chat-icon"
        />
      </div>
    )
  );
};

export default HaptikChat;